import { ForbiddenError, FromRoute, HttpStatusCodes, NotFoundError, Result } from '@resourceful-hono/core';
import type { z } from 'zod';
import { GET_SCHEMA } from './schema.ts';
import { BaseResource } from '../BaseResource.ts';
import { Protected } from '../common/decorators.ts';
import { Permissions } from '../../../services/OAuth/enums.ts';
import { SystemAccount } from '../../../entities/index.ts';

export class SystemAccountsResource extends BaseResource {
  @Protected([Permissions.GetAccount])
  public async GET(@FromRoute('systemKey', GET_SCHEMA) key: z.infer<typeof GET_SCHEMA>) {
    const user = await this.user;
    if (!user.game)
      throw new ForbiddenError('You need to be in a game.');
    const account = await SystemAccount.get(key);

    if (!account)
      throw new NotFoundError(`System account ${key} not found.`);

    if (key === 'free_parking')
      return Result(
        HttpStatusCodes.Ok,
        {
          ...account,
          balance: await account.getBalance(user.game.id),
        }
      );
    else
      return Result(HttpStatusCodes.Ok, account);
  }
}